import React from 'react'
import styled from 'styled-components'
import { Breadcrumb } from '../../Breadcrumb'
import { device } from '../../Breakpoints'
import header from '../../../img/agendamento-visita-topo-b.jpg'
import headerMobile from '../../../img/agendamento-mobile.jpg'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  .pageHeader {
    margin: auto;
    width: 100%;
    display: block;
    @media ${device.mobileL} {
      display: none !important;
    }
  }
  .pageHeaderMobile {
    margin: auto;
    width: 100%;
    display: none;
    @media ${device.mobileL} {
      display: block;
    }
  }
`
const crumbs = [
  { id: 1, link: '/', title: 'Home', icon: true },
  { id: 2, link: '#', title: 'Agendamento' },
]

const View = ({ children }) => (
  <Container>
    <Breadcrumb crumbs={crumbs} />
    <img src={header} alt="Agendamento" className="pageHeader" />
    <img src={headerMobile} alt="Agendamento" className="pageHeaderMobile" />
    <section className="center">{children}</section>
  </Container>
)

export default View
